// 通用轻量埋点 (image beacon, 走 GET GIF, 不受 CORS 限制)
// 和项目现有 tapdb.trackEvent (走 xhr, logstore=tapdb-web) 并行, 用于跨活动的通用查询埋点

// ---- 活动配置 ----
const APP_ID = '58881'                          // TapTap app id
const CODE = 'xcMatchCenter26'                  // 活动短码
export const ACTIVITY_CODE = 'xc-match-2026'    // 活动 code, 导出供 composable / pv 事件用
// -----------------

const ENDPOINT = 'https://tapdb-one-data-sdk-bj.cn-beijing.log.aliyuncs.com/logstores/web-poster-os/track.gif'

// 每次调用都固定带的 base 参数
function baseParams() {
  return {
    APIVersion: '0.6.0',
    'G-UA': navigator.userAgent,
    'G-REFERER': document.referrer,
    'G-URL': location.href,
    // xua: 用户身份, 后续可填 sessionStore.uid 或匿名 uuid; 现留空占位
    xua: '',
    timestamp: Date.now(),
    title: document.title,
    tap_app_id: APP_ID,
    code: CODE,
    content_language: navigator.language,
  }
}

/**
 * 触发一次轻量埋点
 * @param {Object}  opts
 * @param {string}  opts.action  - 事件动作, 如 'pv' / 'page_stay' / 'webevent_click'
 * @param {Object}  [opts.extra] - 业务自定义 payload, 会 JSON.stringify 后作为顶层 extra 参数
 * @param {...*}    opts[任意其他 key] - 其他顶层查询参数 (season_id / stage / stage_no /
 *                                       duration_seconds / object_type / object_id / page_name 等)
 *                                       null / undefined 会被过滤; 空字符串保留 (数据侧占位约定)
 */
export function lightTrack({ action, extra, ...rest }) {
  const raw = { ...baseParams(), action, ...rest }
  if (extra) raw.extra = JSON.stringify(extra)

  const params = new URLSearchParams()
  Object.entries(raw).forEach(([k, v]) => {
    if (v === undefined || v === null) return
    params.append(k, String(v))
  })

  new Image().src = `${ENDPOINT}?${params.toString()}`
}
